import React, { useMemo, useState, useRef, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  Layout,
  Checkbox,
  Row,
  Col,
  Form,
  Input,
  Select,
  Button,
  Radio,
  Collapse,
  AutoComplete,
} from "antd";
import { Trans, useTranslation } from "react-i18next";
import {
  PlusSquareFilled,
  MinusSquareFilled,
  SaveOutlined,
} from "@ant-design/icons";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";
import StepSider from "./StepSider";
import verifybtn from "../../image/verifybtn.png";
import PhoneInput from "react-phone-input-2";
import { getRequest, patchRequest, postRequest } from "../../axios";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import PermissionPanelStep from "./PermissionPanelStep";
import InputField from "../../common/htmlComponents/InputField";
import { authUserData } from "../../utils/Helper";
const onChange = (e) => {
  console.log(`checked = ${e.target.checked}`);
};
const { Content } = Layout;
const handleChange = (value) => {
  console.log(`selected ${value}`);
};
const { Panel } = Collapse;
const AddManageUserGroupStep = () => {
  const navigate = useNavigate();
  const CompanyId = authUserData()?.company ? authUserData()?.company : null;
  const userId = authUserData()?.user_id ? authUserData()?.user_id : null;
  const companyAdmin = authUserData()?.company_role
    ? authUserData()?.company_role
    : null;
  const vendorAdmin = authUserData()?.vendor_role
    ? authUserData()?.vendor_role
    : null;
  const vendorId = authUserData()?.vendor ? authUserData()?.vendor : null;
  const formRef = useRef();

  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const { id } = useParams();
  const groupId = id ? atob(id) : null;
  const [arrow, setArrow] = useState("Show");
  const mergedArrow = useMemo(() => {
    if (arrow === "Hide") {
      return false;
    }
    if (arrow === "Show") {
      return true;
    }
    return {
      pointAtCenter: true,
    };
  }, [arrow]);
  const colors = ["#094E8F"];

  const onChange = (key) => {
    console.log(key);
  };

  const [permissions, setPermissions] = useState([]);
  const [selectedModel, setSelectedModel] = useState(null);
  const [selectedAppLabel, setSelectedAppLabel] = useState(null);
  const [btnLoading, setBtnLoading] = useState(false);
  let initialState;

  initialState = {
    group_name: "",

    role_family: null,
    permissions: [],
  };
  // }else{
  //   const
  // }
  const [state, setState] = useState(initialState);
  const [familyName, setFamilyName] = useState([]);
  const { Option } = AutoComplete;

  const fetchPermissions = async () => {
    try {
      const response = await getRequest(`create-group-permissions/${groupId}/`);

      if (response.data.success) {
        // setPermissions(data.data);
        setState({
          group_name: response.data.response.group_name,
          role_family: response.data.response.role_family,
          permissions: response.data.response.permissions.map(
            (permission) => permission.id
          ),
        });
        // {
        //   "group_name":response.data.response.group_name,
        //   "role_family":response.data.response.role_family,
        // }
        formRef.current.setFieldsValue({
          ...state,
          group_name: response.data.response.group_name,
          role_family: response.data.response.family_name,
        });
      } else {
        console.error("Error fetching permissions:");
      }
    } catch (error) {
      console.error("Error fetching permissions:", error);
    }
  };

  useEffect(() => {
    if (groupId) {
      fetchPermissions();
    }
  }, [groupId]);

  useEffect(() => {
    // if (selectedModel && selectedAppLabel) {
    PRApprovalHierarchyGetById();
    // }
    getFamilyName();
  }, [selectedModel, selectedAppLabel]);
  const PRApprovalHierarchyGetById = async () => {
    setLoading(true);

    try {
      // let apiResponse = await getRequest(
      //   `list-permission/`

      let apiResponse;
      // );
      if (CompanyId) {
        apiResponse = await getRequest(
          `list-permission/?group_name=${companyAdmin}`
          // list-permission/?company_role=company admin
        );
      } else {
        apiResponse = await getRequest(
          `list-permission/?group_name=${vendorAdmin}`
          // list-permission/?company_role=company admin
        );
      }

      if (apiResponse.status) {
        setPermissions(apiResponse.data.data);
        //settotalCount(apiResponse.data.count);
      } else {
        ErrorNotificationMsg(t("error_in_list_prapproval_hierarchy"));
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const getFamilyName = async (data) => {
    await getRequest("role-family/?no_pagination=True", data).then(
      (response) => {
        setFamilyName(response.data.data);
      }
    );
  };
  const handleFamilySelectChange = async (value) => {
    setState({ ...state, role_family: value });
  };
  const handleInputChange = (e) => {
    // const reg = /^[0-9]*$/;
  
    let { name, value } = e.target;
    // if (reg.test(value)) {
    setState({ ...state, [name]: value ? value : null });
  // }
  };

  const getUniqueObjectsByModelName = (permissions) => {
    const uniqueObjects = [];
    const modelNames = new Set();

    permissions.forEach((permission) => {
      if (!modelNames.has(permission.model)) {
        modelNames.add(permission.model);
        uniqueObjects.push(permission);
      }
    });

    return uniqueObjects;
  };
  const uniquePermissions = useMemo(
    () => getUniqueObjectsByModelName(permissions),
    [permissions]
  );

  // const uniqueModelNames = useMemo(() => getUniqueModelNames(permissions), [permissions]);
  // useEffect(() => {
  //   PRApprovalHierarchyGetById();
  // }, [reload, state]);
  const handleSubmit = async () => {
    setBtnLoading(true);

    const payload1 = { ...state, company: CompanyId };
    let payload;
    if (CompanyId) {
      payload = {
        ...state,

        company: CompanyId,
      };
    } else if (vendorId) {
      payload = {
        ...state,
        vendor: vendorId,
      };
    }

    try {
      let apiResponse;

      if (groupId === null) {
        apiResponse = await postRequest("create-group-permissions/", payload);
      } else {
        apiResponse = await patchRequest(
          `create-group-permissions/${groupId}/`,
          payload
        );
      }
      if (apiResponse.data.success) {
        SuccessNotificationMsg(
          groupId === null
            ? t("Group added successfully")
            : t("Group updated succesfully")
        );
        // setState(initialState);
        // formRef.current.setFieldsValue(initialState);
        // navigate("/company-material");
        updateSubscriptionStatus();

        navigate("/user-manage-group-step");
      } else {
        ErrorNotificationMsg(t("Error in group"));
      }
      setBtnLoading(false);
    } catch (error) {
      setBtnLoading(false);
    }
  };
  const updateSubscriptionStatus = async () => {
    const response = await getRequest(`user-detail/${userId}`);

    localStorage.setItem("auth_data", JSON.stringify(response.data.data));
  };


  return (
    <>
      <Layout>
        <StepSider />
        <Content className="corecontent">
           <div className="ListingTopBar">
                        <div className="pagenamewrap">
                          <div className="pagename">
                          
                             {groupId ? (
                <h3>Edit User Group</h3>
              ) : (
                <h3>Add User Group</h3>
              )}
                
                            {/* <Breadcrumb className="Breadcrumb-Sec">
                              <Breadcrumb.Item>
                                <Link to="/dashboard">Dashboard</Link>
                              </Breadcrumb.Item>
                
                              <Breadcrumb.Item>Material Master</Breadcrumb.Item>
                            </Breadcrumb> */}
                            </div>
                    
                          
                        </div>
                      </div>
          <div className="stepscontentwrap">
          
            <Form onFinish={handleSubmit} autoComplete="off" ref={formRef} className="tabscrolldivwrap">
              <div className="tabscrolldiv">
              <div className="stepsContent">
                <div className="formwrapper">
                  <Row gutter={16}>
                    <Col xs={24} sm={24} md={12} xl={8} xxl={6}>
                      <Form.Item>
                        <InputField
                          name="group_name"
                          label={t("Functional Designation")}
                          placeholder={t("Enter Functional Designation")}
                          rules={t("Enter valid designation")}
                          // pattern={"^[a-zA-Z ()]+$"}
    // const reg = /^[0-9]*$/;

                          handleInputChange={handleInputChange}
                          max={50}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12} xl={8} xxl={6}>
                      <Form.Item
                        name="role_family"
                        label=" Family Name"
                        rules={[
                          {
                            required: true,
                            message: <Trans>Please select family</Trans>,
                          },
                        ]}
                      >
                        <Select
                          showArrow
                          showSearch
                          optionFilterProp="children"
                          placeholder="Select Family"
                          onChange={(value) => handleFamilySelectChange(value)}
                        >
                          {familyName.map((item) => (
                            <Option key={item.id} value={item.id}>
                              {item.family_name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  </Row>
                  <div className="sectiontitle"><span>Permissions</span></div>

                  <div style={{ paddingRight: "5px" }}>
                    {/* <Collapse defaultActiveKey={['1']} onChange={onChange}> */}
                    {/* {uniqueModelNames.map((modelName) => ( */}
                    {uniquePermissions.map((permission, index) => {
                      return (
                        <>
                          {groupId !== null && groupId !== undefined ? (
                            <PermissionPanelStep
                              appLabel={permission.content_type_id}
                              modelName={permission.model.toLowerCase()}
                              groupId={groupId}
                              state={state}
                              setState={setState}
                              index = {index}
                            />
                          ) : (
                            <PermissionPanelStep
                              appLabel={permission.content_type_id}
                              modelName={permission.model.toLowerCase()}
                              state={state}
                              setState={setState}
                            />
                          )}
                        </>
                      );
                    })}
                    {/* <PermissionPanelStep appLabel={63} modelName="employee" state={state} setState={setState} /> */}
                    {/* <PermissionPanelStep appLabel={64} modelName="companydocument" state={state} setState={setState} />
                    <PermissionPanelStep appLabel={64} modelName="companydocument" state={state} setState={setState} /> */}
                    {/* <PermissionPanelStep appLabel={9} modelName="group" /> */}

                    {/* </Collapse> */}
                  </div>
                  {/* </Form> */}
                </div>
              </div>
              </div>
              <div className="stepsFooter">
                <Button
                  cursor="pointer"
                  type="secondary"
                  className="primary"
                  onClick={() => navigate("/user-manage-group-step")}
                >
                  Previous
                </Button>
                <Button
                  cursor="pointer"
                  type="primary"
                  className="primary"
                  htmlType="Submit"
                  label={t("save")}
                  loading={btnLoading}
                  // onClick={()=>handleSubmit()}
                >
                  Save
                </Button>
              </div>
            </Form>
          </div>
        </Content>
      </Layout>
    </>
  );
};

export default AddManageUserGroupStep;
